import ArticleListPage from './ArticleList/ArticleListPage';
import ArticlePage from './Article/ArticlePage';

import {
    PATH_KNOWLEDGE,
    PATH_KNOWLEDGE_ARTICLE,
    PATH_KNOWLEDGE_ALL_ARTICLES,
} from './paths';

const routes = [
    {
        path: PATH_KNOWLEDGE,
        component: ArticleListPage,
        private: false,
        exact: true,
        title: 'route-title/knowledge',
        mobileAppTabIdentifier: 'more',
    },
    {
        path: PATH_KNOWLEDGE_ARTICLE,
        component: ArticlePage,
        private: false,
        exact: true,
        title: 'route-title/knowledge',
        mobileAppTabIdentifier: 'more',
    },
    {
        path: '/oxy365',
        redirectTo: PATH_KNOWLEDGE_ALL_ARTICLES,
        exact: true,
    },
];

export { routes };
